import "./ActionRequired.scss";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import Action from "./Action";
import RedFlagIcon from "../Shared/icons/RedFlagIcon";
import {
  filterBySearch,
  getHelpRequestsSum,
  getIncStaleItemsSum,
  getReadyToFinishSum,
  getRiskAssessmentsSum,
} from "../../utils/Utils";
import { setActionRequiredId } from "src/store/features/applications/applicationsSlice";
import { getIsFurtherReviewEnabledForApplication } from "src/services/AdminDashService";
import { Features } from "src/types/Redux";

const ActionRequired = () => {
  const applications = useAppSelector(
    (state) => state.applications.applications
  );
  const searchTerms = useAppSelector((state) => state.applications.searchTerms);
  const selectedActionId = useAppSelector(
    (state) => state.applications.selectedActionId
  );
  const helpRequests = useAppSelector(
    (state) => state.applications.helpRequests
  );
  const dispatch = useAppDispatch();

  const filteredApps =
    applications || helpRequests
      ? filterBySearch(applications, searchTerms)
      : [];
  const configuration = useAppSelector(
    (state) => state.applications.configuration
  );

  const helpRequestsSum =
    (applications && helpRequests && getHelpRequestsSum(filteredApps)) || 0;
  const incStaleItemsSum =
    (applications && getIncStaleItemsSum(filteredApps)) || 0;
  const readyToFinishSum =
    (applications && getReadyToFinishSum(filteredApps)) || 0;
  const riskAssessmentsSum =
    (applications && getRiskAssessmentsSum(filteredApps, configuration)) || 0;

  const isFurtherReviewEnabledForAny = filteredApps?.some((app) =>
    getIsFurtherReviewEnabledForApplication(
      configuration?.features as Features,
      app
    )
  );

  const actions = [
    {
      id: "avb-actions-total",
      text: "Total Actions",
      value:
        helpRequestsSum +
        incStaleItemsSum +
        readyToFinishSum +
        (isFurtherReviewEnabledForAny ? riskAssessmentsSum : 0),
    },
    {
      id: "avb-actions-help-requests",
      text: "Help Requests",
      value: helpRequestsSum,
    },
    {
      id: "avb-actions-inc-stale-items",
      text: "Incomplete Stale Items",
      value: incStaleItemsSum,
    },
    {
      id: "avb-actions-ready-to-finish",
      text: "Ready to FINISH",
      value: readyToFinishSum,
    },
    isFurtherReviewEnabledForAny && {
      id: "avb-actions-risk-assessments",
      text: "Risk Assessments",
      value: riskAssessmentsSum,
    },
  ].filter(Boolean);

  const onActionClick = (actionId) => {
    dispatch(setActionRequiredId(actionId));
  };

  return (
    <div id="avb-actions-required">
      <div className="action-heading">
        <RedFlagIcon className="flag-icon" />
        <span>ACTION REQUIRED</span>
      </div>
      <div className="actions-container">
        {actions.map((action) => (
          <Action
            action={action}
            actionClick={onActionClick}
            key={action.id}
            selected={action.id === selectedActionId}
          />
        ))}
      </div>
    </div>
  );
};

export default ActionRequired;
